<script setup lang="ts">
  import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle
  } from '@/components/ui/dialog'
  import { Button } from '@/components/ui/button'
  import { useTranslation } from '@/composables/useTranslation'

  interface Props {
    open: boolean
    source?: 'email' | 'export'
    caseUuid?: string
  }

  interface Emits {
    (e: 'update:open', value: boolean): void
    (e: 'cancel'): void
    (e: 'review'): void
  }

  const props = withDefaults(defineProps<Props>(), {
    source: 'export'
  })
  const emit = defineEmits<Emits>()

  const { t } = useTranslation({
    en: {
      title: 'Action Required',
      description:
        'New proposals for important participant details have not yet been confirmed. Please review them before proceeding.',
      cancel: 'Cancel',
      review: 'Review Participant Details'
    },
    de: {
      title: 'Erforderliche Maßnahme',
      description:
        'Neue Vorschläge für wichtige Beteiligtedetails wurden noch nicht bestätigt. Bitte überprüfen Sie diese, bevor Sie fortfahren.',
      cancel: 'Abbrechen',
      review: 'Beteiligtedetails überprüfen'
    }
  })

  const handleCancel = () => {
    emit('cancel')
    emit('update:open', false)
  }

  const handleReview = () => {
    emit('review')
    emit('update:open', false)
  }
</script>

<template>
  <Dialog
    :open="open"
    @update:open="(value) => emit('update:open', value)"
  >
    <DialogContent class="gap-6">
      <DialogHeader class="gap-2">
        <DialogTitle>{{ t('title') }}</DialogTitle>
        <DialogDescription>
          {{ t('description') }}
        </DialogDescription>
      </DialogHeader>
      <DialogFooter>
        <Button
          class="flex-1"
          variant="secondary"
          @click="handleCancel"
        >
          {{ t('cancel') }}
        </Button>
        <Button
          class="flex-1"
          @click="handleReview"
        >
          {{ t('review') }}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
</template>
